// extracted by mini-css-extract-plugin
export default {"hintButtonContainer":"Hints_hintButtonContainer__7c-Bv","hintBox":"Hints_hintBox__wrNV0","button":"Hints_button__9hByU"};